module.exports = __webpack_public_path__ + "img/1.mobile.forbiden.e425861f.png";